import { useFormContext } from 'react-hook-form';

import type { ContactFormSchema } from '../schemas';

export const useContactFormContext = () => {
  const context = useFormContext<ContactFormSchema>();

  return context;
};
